import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-custom-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-dropdown.component.html',
  styleUrl: './custom-dropdown.component.scss'
})
export class CustomDropdownComponent {

  @Input() options: string[] = [];
  @Input() selected: string | null = null;

  @Output() selectedOption = new EventEmitter<string>();

  public isDropdownOpen = true;

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectAssignment(option: string): void {
    this.selected = option;
    this.selectedOption.emit(option);
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {

    const path = event.composedPath();
    if (!path.some(el => (el as HTMLElement).classList?.contains('custom-assignment-dropdown'))) {
      this.isDropdownOpen = false;
    }
  }
}
